import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Clock, Download } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export const FinalCTA: React.FC = () => {
  const {
    t
  } = useLanguage();
  return <section id="precio" className="py-32 bg-dark text-white relative overflow-hidden" data-id="element-29">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl neon-green-bg" data-id="element-30"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full blur-3xl neon-green-bg-alt" data-id="element-31"></div>

      <div className="container mx-auto px-6 max-w-4xl text-center relative z-10" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-33">
          <h2 className="text-5xl md:text-6xl font-bold mb-8 text-white" data-id="element-34">
            {t('cta.title.1')}{' '}
            <span className="text-coral-400 italic" data-id="element-35">{t('cta.title.2')}</span>.
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 font-sans font-light mb-12 max-w-2xl mx-auto" data-id="element-36">
            {t('cta.subtitle')}
          </p>

          <div className="flex flex-col items-center justify-center space-y-6" data-id="element-37">
            <Button className="w-full sm:w-auto text-xl px-12 py-6 shadow-coral-500/20" onClick={() => window.open('https://allopenwellness.com/cart/46880078364803:1', '_blank')} data-id="element-38">
              {t('cta.btn.1')}
            </Button>

            <div className="flex items-center space-x-6 text-sm text-gray-400 font-sans mt-8" data-id="element-39">
              <div className="flex items-center" data-id="element-40">
                <Shield className="w-4 h-4 mr-2 text-coral-400" data-id="element-41" />
                <span data-id="element-42">{t('cta.trust.1')}</span>
              </div>
              <div className="flex items-center" data-id="element-43">
                <Clock className="w-4 h-4 mr-2 text-coral-400" data-id="element-44" />
                <span data-id="element-45">{t('cta.trust.2')}</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};